/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { cloneElement } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiGlobalToastListItem = ({
  children,
  isDismissed
}) => {
  if (!children) {
    return null;
  }

  const classes = classNames('euiGlobalToastListItem', children.props.className, {
    'euiGlobalToastListItem-isDismissed': isDismissed
  });
  return cloneElement(children, { ...children.props,
    ...{
      className: classes
    }
  });
};
EuiGlobalToastListItem.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  isDismissed: PropTypes.bool,

  /**
     * ReactElement to render as this component's content
     */
  children: PropTypes.element
};

try {
  EuiGlobalToastListItem.__docgenInfo = {
    description: '',
    displayName: 'EuiGlobalToastListItem',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      isDismissed: {
        defaultValue: null,
        description: '',
        name: 'isDismissed',
        parent: {
          fileName: 'app/src/components/toast/global_toast_list_item.tsx',
          name: 'EuiGlobalToastListItemProps'
        },
        required: false,
        type: {
          name: 'boolean'
        }
      },
      children: {
        defaultValue: null,
        description: 'ReactElement to render as this component\'s content',
        name: 'children',
        parent: {
          fileName: 'app/src/components/toast/global_toast_list_item.tsx',
          name: 'EuiGlobalToastListItemProps'
        },
        required: false,
        type: {
          name: 'ReactElement'
        }
      }
    },
    extendedInterfaces: ['CommonProps', 'EuiGlobalToastListItemProps']
  };
} catch (e) {}